import { getAppId } from '@/utils/app-config';
import manifest from '../../../package.json';

const getBuildMetadata = async () => {
  const appId = getAppId();
  const { version } = manifest;

  return {
    appId,
    build: 'browser',
    version,
    platformName: 'passkeys',
    mode: __STANDALONE_MODE__ ? 'standalone' : 'embedded',
    env: __BUILD_METADATA_ENV__,
    dev: __BUILD_METADATA_DEV__,
  };
};

export type GetBuildMetadata = typeof getBuildMetadata;

export default getBuildMetadata;
